function initProductSwatches() {
    const activeLink = document.querySelector('.color-swatch-link.is-active');
    const colorItemCode = document.querySelector('.color-item-code');
    const detailColorItem = document.querySelector('.detail-color-item');
    const selectedColorTitle = document.querySelector('.selected-color-title');
    if (activeLink && colorItemCode) {
        const activeColor = activeLink.dataset.color;
        colorItemCode.textContent = activeColor;
        colorItemCode.dataset.selectedValue = activeColor;
        if (detailColorItem) {
            detailColorItem.textContent = activeColor;
        }
        if (selectedColorTitle && activeColor) {
            selectedColorTitle.textContent = activeColor;
        }
    }
    // Prevent duplicate hover bindings when this init runs multiple times.
    const swatchLinks = document.querySelectorAll('.color-swatch-link');
    swatchLinks.forEach(link => {
        if (link.dataset.swatchHoverBound === '1') return;
        link.dataset.swatchHoverBound = '1';

        link.addEventListener('mouseenter', () => {
            if (colorItemCode) colorItemCode.textContent = link.dataset.color;
            if (selectedColorTitle) selectedColorTitle.textContent = link.dataset.color;
        });

        link.addEventListener('mouseleave', () => {
            if (colorItemCode) colorItemCode.textContent = colorItemCode.dataset.selectedValue;
            if (selectedColorTitle) {
                selectedColorTitle.textContent =
                    colorItemCode?.dataset.selectedValue || selectedColorTitle.textContent;
            }
        });
    });
    // Sync all "+ More Colors" toggles currently in DOM (tabs can re-render markup).
    const toggleButtons = document.querySelectorAll('[data-more-colors-toggle]');
    toggleButtons.forEach((toggleBtn) => {
        const scope =
            toggleBtn.closest('[data-product-section]') ||
            toggleBtn.closest('form') ||
            toggleBtn.closest('section') ||
            document;

        const swatchContainer =
            scope.querySelector('.color-variants-full') ||
            scope.querySelector('.color-variants');

        if (!swatchContainer) {
            toggleBtn.classList.add('hide');
            return;
        }
        const links = swatchContainer.querySelectorAll('.color-swatch-link');
        const active = swatchContainer.querySelector('.color-swatch-link.is-active');
        const otherCount = Math.max(0, links.length - (active ? 1 : 0));
        if (otherCount <= 0) {
            toggleBtn.classList.add('hide');
            return;
        }
        toggleBtn.classList.remove('hide');
        const collapsedText = toggleBtn.querySelector('.more-colors-collapsed');
        if (collapsedText) {
            const noun = otherCount === 1 ? 'color' : 'colors';
            collapsedText.textContent = `+${otherCount} More ${noun}`;
        }
        // Default to collapsed when (re)initializing tab content.
        swatchContainer.classList.remove('is-expanded');
        toggleBtn.setAttribute('aria-expanded', 'false');
        const collapsed = toggleBtn.querySelector('.more-colors-collapsed');
        const expandedText = toggleBtn.querySelector('.more-colors-expanded');
        if (collapsed) collapsed.classList.remove('hide');
        if (expandedText) expandedText.classList.add('hide');
        const readLess = scope.querySelector('.readless');
        if (readLess) readLess.classList.add('hide');
    });
    // Bind delegated click handling once so newly injected markup still works.
    if (document.documentElement.dataset.moreColorsDelegatedBound !== '1') {
        document.documentElement.dataset.moreColorsDelegatedBound = '1';
        document.addEventListener('click', (e) => {
            const toggleBtn = e.target?.closest?.('[data-more-colors-toggle]');
            if (!toggleBtn) return;
            e.preventDefault();

            // If the swatches live inside an accordion item and it's closed, open it first.
            const accordionItem = toggleBtn.closest('.product-info-accordion__item');
            if (accordionItem && !accordionItem.classList.contains('active')) {
                const header = accordionItem.querySelector('.product-info-accordion__header');
                if (header && header.getAttribute('aria-expanded') !== 'true') {
                    header.click();
                } else {
                    accordionItem.classList.add('active');
                    if (header) header.setAttribute('aria-expanded', 'true');
                }
            }
            const scope =
                toggleBtn.closest('[data-product-section]') ||
                toggleBtn.closest('form') ||
                toggleBtn.closest('section') ||
                document;
            const swatchContainer =
                scope.querySelector('.color-variants-full') ||
                scope.querySelector('.color-variants');
            if (!swatchContainer) return;
            const readLess = scope.querySelector('.readless');
            const expanded = !swatchContainer.classList.contains('is-expanded');
            swatchContainer.classList.toggle('is-expanded', expanded);
            toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            const collapsed = toggleBtn.querySelector('.more-colors-collapsed');
            const expandedText = toggleBtn.querySelector('.more-colors-expanded');
            if (collapsed) collapsed.classList.toggle('hide', expanded);
            if (expandedText) expandedText.classList.toggle('hide', !expanded);
            if (readLess) readLess.classList.toggle('hide', !expanded);
            // Ensure the color options are visible in the viewport after opening.
            const colorContent = (accordionItem || scope).querySelector?.('.color-option-wrapper');
            if (colorContent) {
                requestAnimationFrame(() => {
                    try {
                        colorContent.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                    } catch (_) {
                        colorContent.scrollIntoView();
                    }
                });
            }
        });
        document.addEventListener('click', (e) => {
            const readLessBtn = e.target?.closest?.('.readless');
            if (!readLessBtn) return;
            const scope =
                readLessBtn.closest('[data-product-section]') ||
                readLessBtn.closest('form') ||
                readLessBtn.closest('section') ||
                document;

            const swatchContainer =
                scope.querySelector('.color-variants-full') ||
                scope.querySelector('.color-variants');
            const toggleBtn = scope.querySelector('[data-more-colors-toggle]');
            if (!swatchContainer || !toggleBtn) return;

            swatchContainer.classList.remove('is-expanded');
            toggleBtn.setAttribute('aria-expanded', 'false');

            const collapsed = toggleBtn.querySelector('.more-colors-collapsed');
            const expandedText = toggleBtn.querySelector('.more-colors-expanded');
            if (collapsed) collapsed.classList.remove('hide');
            if (expandedText) expandedText.classList.add('hide');
            readLessBtn.classList.add('hide');
        });
    }
}
window.initProductSwatches = initProductSwatches;
document.addEventListener('DOMContentLoaded', initProductSwatches);
document.addEventListener('swup:page:view', initProductSwatches);
document.addEventListener('turbo:load', initProductSwatches);
document.addEventListener('turbo:render', initProductSwatches);